import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-outstanding-briefly-report',
  templateUrl: './outstanding-briefly-report.component.html',
  styleUrl: './outstanding-briefly-report.component.scss'
})
export class OutstandingBrieflyReportComponent {

  currentDate: Date;
  
  
    
      constructor(
        private dialogRef: MatDialogRef<OutstandingBrieflyReportComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
      ) {
       
      }
  
      
  
    reportType:any
    startDate :any
    endDate :any
    repName :any
    offRepName:any
    advtName :any
    issueDates:any
    issueDates1:any
    totalAdvtAmount:any
    onlyOutstandingB: any;
    OutstandingB :any;
   onlytotalAdvtAmount: number;
   totalNetAmount : number;
   totalUnpaidAmount : number;
   totalRcvAmount : number;
   totalGstAmount : number;


    ngOnInit(): void {
  
      this.currentDate = new Date();
      debugger
      this.reportType = this.data['reportType'];
      this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
      this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
      this.repName = this.data['repName'];
      this.offRepName = this.data['offRepName'];
      this.advtName = this.data['name'];
      this.issueDates = this.data.issueDates;
      this.issueDates1 = this.data['issue_date'];
  
      const req: any = {
        "rep_name":  this.repName,
        "start_date": this.startDate,
        "end_date": this.endDate,
        "off_rep_name": this.offRepName,
        "advt_name": this.data['name'],
        // // "issue_name" : this.advtName,
        // "issue_date": this.issueDates
        "issue_name": "",
        "issue_date": this.issueDates1
  
  
      }
  
        this.service.getOutstandingB(req).subscribe((data: any) => {
            
      this.OutstandingB = data as any;

      // Reset overall totals
      this.totalAdvtAmount = 0;
      this.totalNetAmount = 0;
      this.totalUnpaidAmount = 0;
      this.totalRcvAmount = 0;
      this.totalGstAmount = 0;

      // Calculate totals for each representative
      this.OutstandingB.forEach(repData => {
        let advTotal = 0;
        let netTotal = 0;
        let balTotal = 0;
        let gstTotal = 0;
        let rcvTotal = 0;

        repData.rep_data.forEach(data1 => {
          advTotal += parseFloat(data1.contract_bkng_advt_amt) || 0;
          gstTotal += parseFloat(data1.contract_gst_amt) || 0;
          netTotal += parseFloat(data1.contract_net_total) || 0;
          rcvTotal += parseFloat(data1.contract_rcv_total) || 0;
          balTotal += parseFloat(data1.contract_bal_amt) || 0;
        });

        // Assign computed totals to each representative
        repData.adv_total = advTotal;
        repData.net_total = netTotal;
        repData.bal_total = balTotal;
        repData.gst_total = gstTotal;
        repData.rcv_total = rcvTotal;

        // Add to overall totals
        this.totalAdvtAmount += advTotal;
        this.totalNetAmount += netTotal;
        this.totalUnpaidAmount += balTotal;
        this.totalRcvAmount += rcvTotal;
        this.totalGstAmount += gstTotal;
      });

    });
  
  
    }
  
  
    exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);
    
    let element = document.getElementById('print-section');
    console.log('Element found:', element);
    
    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }
    
    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);
      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }


  // print() {
  //   const originalTitle = document.title;
  //   document.title = '';
  
  //   const style = document.createElement('style');
  //   style.innerHTML = `
  //     @media print {
  //       table.report-table {
  //         table-layout: auto !important;
  //       }
  
  //       .report-table tr {
  //         break-inside: avoid !important;
  //         page-break-inside: avoid !important;
  //       }
  
  //       .invoice-no {
  //         white-space: normal;
  //         word-break: break-word;
  //         font-weight: bold;
  //         border-right: 1px solid #000;
  //         width: auto !important;
  //         min-width: 150px !important;
  //         max-width: 200px !important;
  //       }
  
  //       .advt-name {
  //         border: 1px solid black;
  //         font-size: 11px;
  //         font-weight: bold;
  //         padding: 4px;
  //         white-space: nowrap;
  //         overflow: hidden;
  //         text-overflow: ellipsis;
  //         max-width: 240px;
  //       }
  
  //       .advt-amt-col {
  //         width: 60px !important;
  //         max-width: 60px !important;
  //       }
  
  //       @page {
  //         size: A4;
  //         margin: 20mm;
  //       }
  
  //       .noPrint {
  //         display: none !important;
  //       }
  
  //       #print-section,
  //       #print-section * {
  //         visibility: visible;
  //       }
  
  //       #print-section {
  //         position: relative;
  //       }
  
  //       .print-footer {
  //         position: fixed;
  //         bottom: 10px;
  //         left: 0;
  //         right: 0;
  //         text-align: center;
  //         font-size: 12px;
  //         color: gray;
  //       }
  
  //       .print-footer::after {
  //         content: "Page " counter(page) " of " counter(pages);
  //       }
  //     }
  //   `;
  
  //   document.head.appendChild(style);
  
  //   setTimeout(() => {
  //     const printTrigger = document.getElementById('print-button');
  //     if (printTrigger) {
  //       (printTrigger as HTMLElement).click();
  //     }
  //     document.title = originalTitle;
  //   }, 500);
  // }

print() {
    const printSection = document.getElementById('print-section');
    if (!printSection) {
        console.error("Print section not found!");
        return;
    }

    const printContent = printSection.innerHTML;
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;

    const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page {
                                size: A4 portrait;
                                margin: 5mm;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 9px !important;
                            }
                            .print-section {
                                width: 100%;
                                margin: 0 auto;
                                padding: 0;
                            }
                            table {
                                width: auto !important;
                                border-collapse: collapse;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 1px solid black !important;
                            }
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            th, td {
                                padding: 2px 3px !important;
                                border: 1px solid black !important;
                                font-size: 9px;
                                line-height: 1.2;
                                white-space: nowrap;
                            }
                            th {
                                background-color: #f2f2f2;
                                font-weight: bold;
                            }
                            tr {
                                border-bottom: 1px solid black !important;
                            }
                            tr.header-row {
                                display: table-header-group;
                            }
                            td[data-type="number"],
                            td.amount,
                            td.balance-value,
                            td:nth-child(n+12) {
                                text-align: right !important;
                            }
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            .br-right { border-right: 1px solid black !important; }
                            .br-rightt { border-right: 4px solid black !important; }
                            .br-bottom { border-bottom: 2px solid black !important; }
                            .br-top { border-top: 2px solid black !important; }
                            .noPrint { display: none !important; }
                            .footer-line {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 1px;
                                background-color: black;
                            }
                            /* Ensure all borders are displayed */
                            table, th, td {
                                border-style: solid !important;
                                border-width: 1px !important;
                                border-color: black !important;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                        <div class="footer-line"></div>
                    </div>
                    <script>
                        window.onload = function() {
                            const table = document.querySelector('table');
                            if (!table) {
                                console.error("Table not found");
                                return;
                            }

                            // Auto-size columns based on content
                            table.style.width = 'auto';
                            const cols = table.querySelectorAll('td, th');
                            cols.forEach(cell => {
                                cell.style.width = 'auto';
                                cell.style.whiteSpace = 'nowrap';
                            });

                            // Alignment processing
                            const cells = document.querySelectorAll('td');
                            cells.forEach(cell => {
                                const content = cell.textContent.trim();

                                if (content.includes('येणे') ||
                                    content.includes('Opening Balance') ||
                                    content.match(/^\\d+\\s+येणे$/) ||
                                    content.includes('Balance C/F') ||
                                    content.includes('Total')) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('balance-value');
                                }

                                const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                                if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                    cell.style.textAlign = 'right';
                                    cell.classList.add('amount');
                                }

                                cell.style.border = '1px solid black';
                            });

                            setTimeout(() => {
                                window.print();
                                setTimeout(() => { window.close(); }, 500);
                            }, 200);
                        };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    } else {
        console.error("Failed to open print window.");
    }
}


}
